import { useState } from "react";
import { Modal } from "antd";
import { notify } from "@/shared/utils/notify";
import {
  deleteProductCategories,
  productCategoriesChangeModalState,
  refreshTableProductCategories,
  setIsProductCategoriesForUpdate,
  setProductCategoriesForUpdate,
} from "../../../redux";
import { IProductCategory } from "../../../redux/@types";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { AlertTriangle } from "lucide-react";

import { useProductCategories } from "./useProductCategories";
import { useNavigate } from "react-router-dom";

const { confirm } = Modal;

export const useTableProductCategories = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { tableProps } = useProductCategories();
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [transferSourceCategory, setTransferSourceCategory] = useState<IProductCategory | null>(null);

  const navigateSingleCategory = (user: IProductCategory) => {
    dispatch(setProductCategoriesForUpdate(user));
    localStorage.setItem("singleCategory", JSON.stringify(user));
    navigate(`/productCategories/${user.id}`);
  };

  const changeProductCategoriesForUpdate = (user: IProductCategory) => {
    dispatch(setIsProductCategoriesForUpdate(true));
    dispatch(setProductCategoriesForUpdate(user));
    dispatch(productCategoriesChangeModalState());
  };

  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: (
        <div style={{ fontSize: "18px", fontWeight: 600, color: "#2d3748", marginBottom: "8px" }}>
          ¿Eliminar categoría?
        </div>
      ),
      icon: (
        <div style={{ 
          width: "48px", 
          height: "48px", 
          borderRadius: "12px", 
          backgroundColor: "#fff3e6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "16px"
        }}>
          <AlertTriangle size={24} color="#ff6b00" />
        </div>
      ),
      content: (
        <div style={{ color: "#718096", fontSize: "14px", lineHeight: "1.6" }}>
          Estás a punto de eliminar la categoría <strong style={{ color: "#2d3748" }}>"{val}"</strong> (ID: {valId}).
          <br /><br />
          Esta acción no se puede deshacer. ¿Deseas continuar?
        </div>
      ),
      okText: "Sí, eliminar",
      okType: "danger",
      cancelText: "Cancelar",
      keyboard: true,
      maskClosable: true,
      centered: true,
      okButtonProps: {
        style: {
          borderRadius: "8px",
          height: "40px",
          fontWeight: 500,
          padding: "0 24px",
        }
      },
      cancelButtonProps: {
        style: {
          borderRadius: "8px",
          height: "40px",
          fontWeight: 500,
          padding: "0 24px",
        }
      },
      async onOk() {
        await deleteProductCategories(valId)
          .then((res) => {
            dispatch(refreshTableProductCategories(true));
            if(res){
              notify.error(`${res}`);
            }else{
              notify.success(
                `Categoría "${val}" eliminada correctamente`
              );
            }
            tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            notify.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  const openTransferModal = (category: IProductCategory) => {
    setTransferSourceCategory(category);
    setTransferModalOpen(true);
  };

  const closeTransferModal = () => {
    setTransferModalOpen(false);
    setTransferSourceCategory(null);
  };

  return {
    navigateSingleCategory,
    changeProductCategoriesForUpdate,
    showDeleteConfirm,
    openTransferModal,
    closeTransferModal,
    transferModalOpen,
    transferSourceCategory,
    tableProps,
  };
};
